import { Link } from "react-router-dom";
import parlerEcole from "../assets/images/parler-regles-ecole.png";

function SchoolSpeakHome() {

	return (
		<div className="parlerEcole">
			<div className="parlerEcole__left-container">
				<div className="parlerEcole__title-container">
					<h2 className="parlerEcole__title">Parler des règles <br /><strong><i>dans mon école, collège ou lycée</i></strong></h2>
					<p className="parlerEcole__subtitle">Peu importe ta situation, il y a toujours un moyen pour parler des règles !</p>
				</div>
			</div>
			<div className="parlerEcole__right-container">
				<div className="parlerEcole__img-container">
					<Link to="https://doccollectes.blob.core.windows.net/parlons-regles/arbre-choix_parler_regles_dans_etablissement_scolaire.pdf" target="_blank" rel="noreferrer">
						<img src={parlerEcole} alt="Guide : parler des règles dans mon établissement" />
					</Link>
					<div className="parlerEcole__button-container">
						<Link to="https://doccollectes.blob.core.windows.net/parlons-regles/arbre-choix_parler_regles_dans_etablissement_scolaire.pdf" target="_blank" rel="noreferrer">
							<button className="parlerEcole__button" type="button">
								Voir le guide en entier
							</button>
						</Link>
					</div>					
				</div>									
			</div>
		</div>
	);
}

export default SchoolSpeakHome;